document.addEventListener('turbolinks:load', () => {
  $('.js-select2').select2();
});
